<template>
    <div>

        <b-card class="shadow-sm" header-class="bg-gray-50">
            <template #header>
                <transition name="fade-faster" mode="out-in">
                    <div v-if="hasDetailResponse" :key="rfxResponseId" class="d-flex justify-content-between align-items-center">
                        <div>
                            <div class="d-flex justify-content-end align-items-center">
                                <!-- <b-badge
                                    :variant="respData.state_dict.color_variant"
                                    class="mr-2 font-size-80"
                                    v-b-tooltip.hover
                                    :title="respData.state_dict.text"
                                >
                                    {{ respData.state_dict.title.toUpperCase() }}
                                </b-badge> -->
                                <status-object-badge
                                    :status-object="respData.state_dict"
                                    text-uppercase
                                    font-size="0.9rem"
                                ></status-object-badge>
                                <!-- <b-link
                                    class="mr-2 d-inline-block star-link text-decoration-none text-center"
                                    :class="respData.is_starred ? 'starred' : ''"
                                    href="#"
                                    @click="updateIsStarred(respData)"
                                    style="min-width: 80px;"
                                >
                                    <b-spinner v-if="loadingStarred" key="loadingStarred" small variant="warning" class="mr-1"></b-spinner>
                                    <b-icon v-else key="loadedStarred" :icon="respData.is_starred ? 'star-fill' : 'star'" class="mr-1" font-scale="1.2"></b-icon>
                                    <span class="star-text">
                                        {{respData.is_starred ? 'Starred' : 'Star'}}
                                    </span>
                                </b-link> -->
                            </div>
                        </div>

                        <div class="">

                            <div
                                v-if="isRfxArchived"
                                key="rfxIsArchived"
                                class="font-size-80 font-weight-600 text-danger-darker text-uppercase"
                            >
                                Event is Archived - No Actions Allowed
                            </div>

                            <div
                                v-else-if="!isRfxArchived"
                                key="adminManageButtons"
                                class="d-flex gap-5"
                            >  <!-- remove rtuIsAdmin in the conditional once you allow non-thread-member admins to write to a thread (as of Dec 5 2022) -->
                                <!-- Can show these things to all internal people, but disable if not an admin, not in possible triggers for that TU -->
                                <div v-if="showLockToggle" class="d-flex align-items-center gap-2">
                                    <div class="text-uppercase text-right text-muted font-size-60 font-weight-500">Vendor<br>Edits</div>
                                    <b-button
                                        size="sm"
                                        :variant="isLocked ? 'outline-white-secondary' : 'subtle-dark'"
                                        v-b-tooltip.hover
                                        :title="isLocked ? 'Unlock response to allow vendor to make changes?' : 'Lock response to prevent vendor from making changes?'"
                                        :disabled="!currentLockTrigger"
                                        @click="callTransitionTrigger(currentLockTrigger)"
                                    >
                                        <b-icon
                                            :icon="isLocked ? 'lock-fill' : 'unlock'"
                                            :variant="isLocked ? 'dark' : 'secondary'"
                                            class="mr-2"
                                        ></b-icon>
                                        <span
                                            class="text-uppercase"
                                            :class="isLocked ? 'text-dark' : ''"
                                        >{{ isLocked ? 'Locked' : 'Unlocked' }}</span>
                                    </b-button>
                                </div>
                                <div v-if="showFlaggedToggle" class="d-flex align-items-center gap-2">
                                    <div class="text-uppercase text-right text-muted font-size-60 font-weight-500">Vendor<br>Follow-Up</div>
                                    <b-button
                                        size="sm"
                                        :variant="isFlagged ? 'outline-white-secondary' : 'subtle-dark'"
                                        v-b-tooltip.hover
                                        :title="isFlagged ? 'Cancel flag for vendor follow-up?' : 'Set flag to request changes from vendor?'"
                                        :disabled="!currentFlaggedTrigger"
                                        @click="callTransitionTrigger(currentFlaggedTrigger)"
                                    >
                                        <b-icon
                                            :icon="isFlagged ? 'flag-fill' : 'flag'"
                                            :variant="isFlagged ? 'danger' : 'secondary'"
                                            class="mr-2"
                                        ></b-icon>
                                        <span
                                            class="text-uppercase"
                                            :class="isFlagged ? 'text-dark' : ''"
                                        >{{ isFlagged ? 'Flagged' : 'Not Flagged' }}</span>
                                    </b-button>
                                </div>

                                <b-button-group
                                    id="dynamic-transitions-buttons"
                                    v-if="filteredTransitions.length > 0"
                                >
                                    <b-button
                                        v-for="trans in filteredTransitions"
                                        :key="trans.trigger"
                                        @click="callTransitionTrigger(trans.trigger)"
                                        size="sm"
                                        variant="subtle-dark"
                                        v-b-tooltip.hover
                                        :title="trans.description"
                                    >
                                        <b-icon :icon="trans.icon" :variant="trans.color_variant" class="mr-1"></b-icon>
                                        {{ trans.label }}
                                    </b-button>
                                </b-button-group>

                                <b-button-group v-if="isSubmitted">
                                    <b-button
                                        v-if="showAwardToggle"
                                        size="sm"
                                        :variant="isAwarded ? 'sharp-success' : 'subtle-dark'"
                                        v-b-tooltip.hover
                                        :title="isAwarded ? 'Remove this vendor from awarded?' : 'Award business to this vendor?'"
                                        @click="callTransitionTrigger(currentAwardTrigger)"
                                    >
                                        <b-icon
                                            :icon="isAwarded ? 'award-fill' : 'award'"
                                            :variant="isAwarded ? 'success' : 'success'"
                                            class="mr-1"
                                        ></b-icon>
                                        {{ isAwarded ? 'Awarded' : 'Award' }}
                                    </b-button>
                                    <b-button
                                        v-if="showRejectToggle"
                                        size="sm"
                                        :variant="isRejected ? 'sharp-danger' : 'subtle-dark'"
                                        v-b-tooltip.hover
                                        :title="isRejected ? 'Undo rejection of this vendor?' : 'Reject this vendor completely?'"
                                        @click="callTransitionTrigger(currentRejectTrigger)"
                                    >
                                        <b-icon
                                            :icon="isRejected ? 'x-octagon-fill' : 'x-octagon'"
                                            :variant="isRejected ? 'danger' : 'danger'"
                                            class="mr-1"
                                        ></b-icon>
                                        {{ isRejected ? 'Rejected' : 'Reject' }}
                                    </b-button>
                                </b-button-group>

                            </div>

                            <!-- <div v-else-if="!rtuIsAdmin" key="notAdmin"></div> -->  <!-- placeholder empty div for layout purposes -->

                        </div>

                    </div>
                    <div v-else class="d-flex justify-content-between">
                        <b-skeleton width="10%"></b-skeleton>
                        <b-skeleton width="40%"></b-skeleton>
                    </div>
                </transition>
            </template>

            <p v-if="error" class="text-danger">{{ errorMsg }}</p>

            <transition name="fade-faster" mode="out-in">
                <div v-if="hasDetailResponse" :key="rfxResponseId">
                    <div class="d-flex justify-content-between align-items-start mb-3">
                        <div>
                            <div class="mb-2 d-flex align-items-center gap-4 flex-wrap">
                                <h3 class="mb-0">{{ respData.vendor_name }}</h3>
                                <featured-vendor-tag-group
                                    :tags="respData.vendor ? respData.vendor.company_tags : []"
                                    tagClass="font-size-80"
                                ></featured-vendor-tag-group>
                                <!-- <b-badge
                                    v-if="!respData.last_submitted_on"
                                    variant="soft-secondary"
                                    class="ml-3 text-uppercase font-size-80"
                                >
                                    Not Yet Submitted
                                </b-badge> -->
                            </div>
                            <p
                                v-if="respData.last_submitted_on"
                                class="card-subtitle small text-muted mb-2"
                            >
                                <span v-if="respData.submitted_by.full_name">Submitted by {{ respData.submitted_by.full_name }} on</span>
                                <span v-else>Submitted on </span>
                                {{ respData.last_submitted_on ? respData.last_submitted_on : null | toLocalDate }}
                            </p>
                        </div>
                        <div>
                            <b-button
                                variant="minimal-primary"
                                :href="respData.vendor.url"
                                target="_blank"
                                size="sm"
                                class=""
                            >
                                Vendor Profile
                                <b-icon icon="box-arrow-up-right" class="ml-1"></b-icon>
                            </b-button>
                            <!-- <b-button
                                variant="minimal-primary"
                                target="_blank"
                                size="sm"
                                class=""
                            >
                                Vendor Website
                                <b-icon icon="box-arrow-up-right" class="ml-1"></b-icon>
                            </b-button> -->
                        </div>
                    </div>
                    <b-tabs
                        no-nav-style
                        nav-class="section-nav"
                        content-class="min-height-500"
                        id="response-tabs"
                        @input="setActiveTabIndex"
                    >
                        <b-tab lazy title="Vendor Profile" :active="initialTab === 'tabProfile'" ref="tabProfile">
                            <div v-if="hasDetailResponse" class="my-4">
                                <div class="mb-5 bg-gray-50 rounded-lg">
                                    <div class="p-2 bg-gray-100 rounded-lg mb-3 special-text text-muted">
                                        <b-icon icon="building" variant="primary" class="mr-2"></b-icon>
                                        Company Information
                                    </div>
                                    <company-detail-form
                                        ref="detailForm"
                                        :company-id="respData.vendor_id"
                                        class=""
                                    ></company-detail-form>
                                </div>

                                <div class="mb-5 bg-gray-50 rounded-lg">
                                    <div class="p-2 bg-gray-100 rounded-lg mb-1 special-text text-muted">
                                        <b-icon icon="people" variant="primary" class="mr-2"></b-icon>
                                        Company Contacts
                                    </div>
                                    <rfx-response-manage-invited-tus
                                        :response-id="respData.id"
                                        class="mx-3 pb-2"
                                    ></rfx-response-manage-invited-tus>
                                </div>
                            </div>

                        </b-tab>

                        <b-tab lazy no-body title="Response Details" :active="initialTab === 'tabCompanyToDos'" ref="tabCompanyToDos">
                            <rfx-response-submission-download-list
                                :response-id="rfxResponseId"
                                class="mt-5"
                            ></rfx-response-submission-download-list>
                            <rfx-response-todo-reply-viewer
                                :response-id="rfxResponseId"
                            ></rfx-response-todo-reply-viewer>
                        </b-tab>

                        <b-tab lazy title="Message Vendor" button-id="external-comments" :active="initialTab === 'externalComments'" ref="externalComments">
                            <template #title>
                                Message Vendor
                                <!-- <b-icon v-if="respData.external_thread_tu_read_status.has_unread" icon="dot" variant="danger" class="mx-0" scale="3"></b-icon> -->
                                <new-badge small v-if="externalThreadHasUnread"></new-badge>
                            </template>
                            <div class="py-4">
                                <base-message-thread
                                    v-if="respData.external_message_thread_id"
                                    :thread-id="respData.external_message_thread_id"
                                    title="Vendor Messages"
                                    subtitle="A single discussion thread for your vendor and your internal team.  Send and receive from here, or from your email account."
                                    create-verb="New"
                                    message-name="message"
                                    title-badge-text="External"
                                    title-badge-variant="soft-danger"
                                    title-badge-class="text-uppercase ml-2"
                                    editor-style="rich"
                                    thread-type="email"
                                    @unread-status="handleExternalThreadUnreadStatus"
                                ></base-message-thread>  <!-- TODO add @updated or other event handlers here -->
                            </div>
                        </b-tab>
                        <b-tab lazy title="Internal Comments" button-id="internal-comments" :active="initialTab === 'internalComments'" ref="internalComments">
                            <template #title>
                                Internal Comments
                                <!-- <b-icon v-if="respData.internal_thread_tu_read_status.has_unread" icon="dot" animation="fade" variant="danger" class="mx-0" scale="2"></b-icon> -->
                                <new-badge small v-if="internalThreadHasUnread"></new-badge>
                            </template>
                            <div class="py-4">
                                <base-message-thread
                                    v-if="respData.internal_message_thread_id"
                                    :thread-id="respData.internal_message_thread_id"
                                    title="Internal Discussion"
                                    subtitle="Add your own comments, or discuss with your internal team.  None of these comments are visible to vendors."
                                    create-verb="Add"
                                    message-name="comment"
                                    title-badge-text="Internal"
                                    title-badge-variant="soft-primary"
                                    title-badge-class="text-uppercase ml-2"
                                    editor-style="textarea"
                                    thread-type="comment"
                                    @unread-status="handleInternalThreadUnreadStatus"
                                ></base-message-thread>  <!-- TODO add @updated or other event handlers here -->
                            </div>
                        </b-tab>
                    </b-tabs>
                </div>
                <div v-else class="py-4 px-3 text-center text-info font-weight-bold">
                    <busy-spinner inner-class="my-7" text="Loading Response..."></busy-spinner>
                </div>
            </transition>
        </b-card>

        <!-- new version -- it knows nothing -- have to pass it everything it needs to call transition -->
        <!-- dec 5 2022 - had v-if=rtuIsAdmin but that seems unnecessary... will only call things if possible anyways -->
        <state-machine-transitions
            ref="transitionsComponent"
            @state-change="onStateChange"
            @loading="handleStateMachineLoading"
            @cancel="onStateChangeCancel"
        ></state-machine-transitions>

    </div>
</template>

<script>

import { suppliosApi } from '../js/api-service';
import isEmpty from 'lodash/isEmpty';
//import cloneDeep from 'lodash/cloneDeep';
import { FormatDecimalHelper, FormatDateHelper } from '../js/filters-helpers';
import { currentUserInfoMixin, tenantInfoMixin } from '../js/custom-vue-mixins';
import RfxResponseTodoReplyViewer from './company_todos/RfxResponseTodoReplyViewer';
import RfxResponseManageInvitedTus from './rfx_internal/RfxResponseManageInvitedTus';
import RfxResponseSubmissionDownloadList from './rfx_internal/RfxResponseSubmissionDownloadList';
import StateMachineTransitions from './StateMachineTransitions';
import { RfxResponse } from '../js/models/rfxResponse';  // class constructor
import { Rfx } from '../js/models/rfx';  // class constructor
import StatusObjectBadge from '../components/functional-comps/StatusObjectBadge';
import FeaturedVendorTagGroup from './vendors/components/FeaturedVendorTagGroup.vue';

export default {
    name: 'RfxResponseInternalDetail',
    components: {
        RfxResponseTodoReplyViewer,
        RfxResponseManageInvitedTus,
        RfxResponseSubmissionDownloadList,
        StateMachineTransitions,
        StatusObjectBadge,
        FeaturedVendorTagGroup,
    },
    mixins: [
        currentUserInfoMixin,
        tenantInfoMixin,
    ],
    props: {
        rfxResponseId: {
            type: [String, Number],
            required: true,
        },
        initialTab: {  // if you want to start with a specific tab on mount, put here - use tab ref names (by convention, you're matching the ref name, but doesn't actually use refs)
            // options:  'tabProfile', 'tabCompanyToDos', 'externalComments', 'internalComments'
            type: String,
            default: '',  // just default to empty string to prevent problems
        },
        /* rtuRole: {  // role of the RfxTenantUser - 'admin', 'decision', 'requester'
            type: String,
            required: true,
        } */
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loadingTransition: false,
            loadingUpdate: false, // set true when we call upate from the parent
            loadingStarred: false,  // toggle when setting star status via API
            respData: {},  // instance of RfxResponse will go here after api call
            rfxData: {},  // you may not need it, but you are passing back rfx nested in response... we'll pull that out, make Rfx class instance and put here
            loadingDetailResponse: false,
            activeTabIndex: null,  // will get updated via @input on b-tabs
            localExternalThreadHasUnread: null,  // Boolean, will update from @unread-status handler on external thread
            localInternalThreadHasUnread: null,  // Boolean, will update from @unread-status handler on internal thread
            // IF YOU ADD ANY OTHER DATA ITEMS, MAKE SURE YOU RESET THEM...
            // ...IF YOU'RE STILL REUSING THIS SAME COMPONENT FOR MULTIPLE RESPONSES USING .update() METHOD CALLED FROM PARENT!!!
            // data properties just for controlling states of lock/flagged toggles
        }
    },
    computed: {
        // has currentUserInfo from mixin
        rtuIsAdmin: function() {
            // previously we were passing in this.rtuRole as a prop, but that's not great long term...
            // changed to get it from API when getting all other response data
            // OLD: return this.rtuRole === 'admin';
            if (!this.hasDetailResponse) return false;
            if (!this.respData.rtu_role) return false;
            return this.respData.rtu_role === 'admin';
        },
        detailState: function() {
            if (this.loadingDetailResponse) {
                return 'loading';
            } else if (this.hasSelectedResponse) {
                return 'detail';
            } else {
                return 'empty';
            }
        },
        hasDetailResponse: function() {
            if ( !this.respData || isEmpty(this.respData) || this.loadingUpdate ) return false;
            return true;
        },
        externalThreadHasUnread() {
            // return boolean if external thread has unread messages, used to show the notification badge
            // pull from local value first, since that's updated from the @unread-status event on thread component
            return this.localExternalThreadHasUnread ?? this.respData?.external_thread_tu_read_status?.has_unread ?? false;
        },
        internalThreadHasUnread() {
            // return boolean if internal thread has unread messages, used to show the notification badge
            return this.localInternalThreadHasUnread ?? this.respData?.internal_thread_tu_read_status?.has_unread ?? false;
        },
        isSubmitted() {
            // pulling this up to top level for convenience and so we don't have type errors
            return !!this.respData?.is_submitted;
        },
        isRfxArchived() {
            return this.rfxData?.sm_state === 'archived';
        },
        // COMPUTED THINGS ABOUT TRANSITIONS
        // HOW THIS WORKS:
        // - your respData has possible_transitions -- from that, figure out what buttons to show, etc.
        // - then you also have a StateMachineTransitions component -- use public method from that via ref (.triggerTransition('transition_name'))
        // - that component will handle showing the modal for collect_data, and actually making API call -- then when its done it will emit signal back here
        // - you're calling method in child component from method here: this.callTransitionTrigger(trigger_name)
        hasPossibleTransitions() {
            return !!this.respData.possible_transitions?.length;
        },
        possibleTransitionTriggers() {
            // return Array of string names of possible triggers
            if (!this.hasPossibleTransitions) return [];  // empty array if nothing to keep same type
            return this.respData.possible_transitions.map(transObj => transObj.trigger);
        },
        filteredTransitions() {
            // take all possible transitions, and filter out any that you may be handling separately
            // this is what you'll show in the 'dynamic transitions' button area
            const hiddenTriggers = [
                'go_lock_vendor_modify', 'go_unlock_vendor_modify',
                'go_set_is_flagged', 'go_remove_is_flagged',
                'go_reject', 'go_unreject',
                'go_award', 'go_unaward',
                'go_withdraw_submitted',  // should only be for suppliers, might show up for supplios staff, but we don't need it
            ];
            if (!this.hasPossibleTransitions) return [];
            return this.respData.possible_transitions.filter(trans => !hiddenTriggers.includes(trans.trigger));
        },
        showLockToggle() {  // should we even show the lock toggle?  separate from enabling it... because non-admins should see it, but not change it
            return !!this.respData.is_submitted;
        },
        /* enableLockToggle() {  // enable CHANGING the lock status?  (means that TU has access to do so)
            return this.possibleTransitionTriggers.includes('go_lock_vendor_modify') || this.possibleTransitionTriggers.includes('go_unlock_vendor_modify');
        }, */
        isLocked() {
            return !this.respData.can_vendor_modify;  // NOT can_vendor_modify
        },
        currentLockTrigger() {
            // return the trigger name for the lock or unlock trigger, if available, or null if not
            //if (!this.enableLockToggle) return null;
            const findTriggers = ['go_lock_vendor_modify', 'go_unlock_vendor_modify']
            // just look through the list of trigger names, find first one.... should only be one of them!
            const foundTrigger = this.possibleTransitionTriggers.find(trig => findTriggers.includes(trig));
            return foundTrigger ?? null;
        },
        showFlaggedToggle() {  // should we even show the flagged toggle?  separate from enabling it... because non-admins should see it, but not change it
            return !!this.respData.is_submitted;
        },
        /* enableFlaggedToggle() {  // enable CHANGING the flagged status?  (means that TU has access to do so)
            return this.possibleTransitionTriggers.includes('go_set_is_flagged') || this.possibleTransitionTriggers.includes('go_remove_is_flagged');
        }, */
        isFlagged() {
            return !!this.respData.is_flagged_for_vendor;
        },
        currentFlaggedTrigger() {
            // return the trigger name for the set/remove flag trigger, if available, or null if not
            //if (!this.enableFlaggedToggle) return null;
            const findTriggers = ['go_set_is_flagged', 'go_remove_is_flagged']
            // just look through the list of trigger names, find first one.... should only be one of them!
            const foundTrigger = this.possibleTransitionTriggers.find(trig => findTriggers.includes(trig));
            return foundTrigger ?? null;
        },
        showRejectToggle() {  // should we even show the reject toggle?  separate from enabling it... because non-admins should see it, but not change it
            return !!this.respData.is_submitted && !!this.currentRejectTrigger;
        },
        /* enableRejectToggle() {  // enable CHANGING the reject status?  (means that TU has access to do so)
            return this.possibleTransitionTriggers.includes('go_reject') || this.possibleTransitionTriggers.includes('go_unreject');
        }, */
        isRejected() {
            return !!this.respData.sm_state && (this.respData.sm_state == 'rejected');
        },
        currentRejectTrigger() {
            // return the trigger name for the reject/unreject trigger, if available, or null if not
            //if (!this.enableRejectToggle) return null;
            const findTriggers = ['go_reject', 'go_unreject']
            // just look through the list of trigger names, find first one.... should only be one of them!
            const foundTrigger = this.possibleTransitionTriggers.find(trig => findTriggers.includes(trig));
            return foundTrigger ?? null;
        },
        showAwardToggle() {  // should we even show the award toggle?  separate from enabling it... because non-admins should see it, but not change it
            return !!this.respData.is_submitted && !!this.currentAwardTrigger;
        },
        /* enableAwardToggle() {  // enable CHANGING the award status?  (means that TU has access to do so)
            return this.possibleTransitionTriggers.includes('go_award') || this.possibleTransitionTriggers.includes('go_unaward');
        }, */
        isAwarded() {
            return !!this.respData.sm_state && (this.respData.sm_state == 'awarded');
        },
        currentAwardTrigger() {
            // return the trigger name for the award/unaward trigger, if available, or null if not
            //if (!this.enableAwardToggle) return null;
            const findTriggers = ['go_award', 'go_unaward']
            // just look through the list of trigger names, find first one.... should only be one of them!
            const foundTrigger = this.possibleTransitionTriggers.find(trig => findTriggers.includes(trig));
            return foundTrigger ?? null;
        },
        rfxAwardEnabled() {
            // return boolean if show_rfx_award tenant flag is set - maybe don't need this, just change what happens in go_award transition?
            return this.$getTenantFlag('show_rfx_award', false);
        },
    },
    filters: {
        toLocalDate: function(value) {
            return FormatDateHelper(value);
            //return new Date(value).toLocaleDateString();
        },
        toLocalDateTime: function(value) {
            return new Date(value).toLocaleString('en-US', { timeZone: 'UTC' });
        },
        singleDecimal: function(value) {
            return FormatDecimalHelper(value, 1);
        },
    },
    mounted: function() {
        this.getDetailResponse(this.rfxResponseId);
    },
    methods: {
        /* update: function(newRfxResponseId) {  // DEPRECATED Nov 23 2021
            // STILL USING THIS FROM RfxManageResponses - but maybe we shouldn't... change later
            // public function called by parent when changing which response to show
            this.loadingUpdate = true;
            this.rfxResponseId = newRfxResponseId;  // set the new 'local prop' value
            this.getDetailResponse(newRfxResponseId);  // then fetch all the new stuff
        }, */
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        getDetailResponse: function(responsePk) {
            this.loadingDetailResponse = true;
            this.loadingUpdate = true;
            // OLD - removed the general retrieve view for rfxResponse
            // suppliosApi.rfxResponse.retrieve(responsePk)
            suppliosApi.rfxResponse.get_detail_internal(responsePk)
            .then(response => {
                console.log('got detailed rfx response, api response.data below');
                console.log(response.data);
                this.rfxData = new Rfx(response.data.rfx);
                this.respData = new RfxResponse(response.data);
            })
            .catch(error => this.handleError(error, 'Error while getting response detail'))
            .finally(() => {
                this.loadingDetailResponse = false;
                this.loadingUpdate = false;
            })
        },
        updateIsStarred: function() {
            // handles click on star toggle
            // removed all this logic since it didn't make sense, but keeping UI stuff because you might use later
            // update later if needed
            console.log('update starred');
            this.loadingStarred = true;
            // make api call
            this.loadingStarred = false;
            this.emitUpdated(); // maybe wait until AFTER the api call comes back
        },
        activateTab: function(tabRefName) {
            // activate a certain tab on detail area -- pass in tab ref="tabSomething" name
            // pass value as STRING like this:  @click="activateTab('tabMessages')"
            // this won't work on initial load, since not all tabs will be mounted when parent component mounts (I think that's why)
            let tabRef = this.$refs[tabRefName];
            tabRef.activate();
        },
        setActiveTabIndex: function(newTabIndex) {
            // just update local data value of tab index - verify this works with all the ways you can activate tabs (by clicking, calling .activate(), etc)
            this.activeTabIndex = newTabIndex;
        },
        // HANDLING TRANSITIONS
        callTransitionTrigger(triggerName) {
            console.log(`hello from callTransitionTrigger - will call ${triggerName}`);
            // this calls the transition using the StateMachineTransitions component via $refs
            // we must pass the entire transitionObject, the suppliosApi endpoint string, and the instance ID that we want to transition
            // so we have to look some things up first if we're only passing in the trigger name
            const transComponent = this.$refs['transitionsComponent'];
            if (!transComponent) return;
            const transitionObject = this.respData.possible_transitions.find(trans => trans.trigger === triggerName);
            if (!transitionObject) {
                this.$toast.error('That action is not available.  Please contact Supplios Support.');
                return;
            }
            const callTransitionEndpoint = 'rfxResponse.call_transition';
            transComponent.trigger(transitionObject, callTransitionEndpoint, this.rfxResponseId);
            // then that component will emit 'state-change' with newState (string name of state)
            // handle that in other callback below
        },
        onStateChange(stateChangeResponse) {
            // called when handling emitted 'state-change' event from StateMachineTransitions component (after it did the transition)
            // stateChangeResponse will be { success, message, object }
            console.log(`state changed - apiResponse below`);
            console.log(stateChangeResponse);
            this.getDetailResponse(this.rfxResponseId);
            // also must emit @updated to tell parent list if we're in ManageResponses
            this.emitUpdated();  // no payload?  we don't want to wait until we get new detail response here... do them in parallel
        },
        onStateChangeCancel() {
            // called anytime the state change modal / process is cancelled
            // we need to re-check our button states if computed props didn't update...
            console.log('state change cancelled');
            // we may have to force update any components that have props from computed things here -- like checkboxes that can call transitions
            // USING .$forceUpdate() DOES NOT WORK
        },
        emitUpdated() {
            // emit 'updated' event to parent to reload list, etc.
            // probably don't use a payload.... you want to emit this when you know data is updated in DB, but don't want to also wait for this component to get updated data
            // and you don't know what format of data the parent wants... so just say 'updated' and let parent figure out what to do
            this.$emit('updated');
        },
        handleStateMachineLoading(loadingState) {
            // handler for @loading on transition component - payload will be boolean of its loading state
            this.loadingTransition = loadingState;
        },
        handleInternalThreadUnreadStatus(hasUnread) {
            this.localInternalThreadHasUnread = hasUnread;
        },
        handleExternalThreadUnreadStatus(hasUnread) {
            this.localExternalThreadHasUnread = hasUnread;
        },
    }
}
</script>

<style>

</style>
